import { createFileRoute, redirect } from "@tanstack/react-router"
import * as z from "zod"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { pick } from "@repo/utils/collections"
import { sharedConfig } from "~/lib/config/shared"
import { AuthLayout } from "~/modules/auth/components/auth-layout"
import { ForgotPasswordForm } from "./forgot-password-form"

const searchSchema = z.looseObject({
  email: z.email().catch(""),
})

export const Route = createFileRoute("/_auth-layout/auth/forgot-password")({
  component: ForgotPasswordScreen,
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => pick(search, ["email"]),
  beforeLoad: ({ context }) => {
    if (context.user) {
      throw redirect({
        to: "/",
      })
    }
  },
  head: ({ match }) => ({
    meta: generateMetaTags({
      robots: ["noindex", "nofollow", "noarchive"],
      base: {
        title: `Forgot Password | ${sharedConfig.appName}`,
        description: `Reset your password for ${sharedConfig.appName}`,
        url: new URL(match.fullPath, sharedConfig.baseUrl).toString(),
      },
    }),
  }),
})

function ForgotPasswordScreen() {
  const { email } = Route.useSearch()

  return (
    <AuthLayout title="Forgot password">
      <ForgotPasswordForm email={email} />
    </AuthLayout>
  )
}
